import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import "../../../assets/css/student/home/HomeSubScreen.css";

function HomeSubScreen() {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({
    donations: 0,
    families: 0,
    communities: 0,
    projects: 0
  });
  const [loading, setLoading] = useState(false);

  const sectionRef = useRef(null);
  const navigate = useNavigate();

  // Target values
  const targets = {
    donations: 23,
    families: 10,
    communities: 50,
    projects: 100
  };

  const handleDonorLogin = () => {
    setLoading(true);
    setTimeout(() => {
      navigate("/donor/login");
    }, 800);
  };

  // Intersection Observer - jab section view me aaye
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 } // 30% visible hone par start
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [isVisible]);

  // Counter Animation
  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000; // 2 seconds
    const steps = 60; // 60 frames
    const stepDuration = duration / steps;

    const intervals = {
      donations: setInterval(() => {
        setCounts(prev => {
          if (prev.donations >= targets.donations) {
            clearInterval(intervals.donations);
            return prev;
          }
          return { ...prev, donations: prev.donations + 1 };
        });
      }, stepDuration),

      families: setInterval(() => {
        setCounts(prev => {
          if (prev.families >= targets.families) {
            clearInterval(intervals.families);
            return prev;
          }
          return { ...prev, families: prev.families + 1 };
        });
      }, stepDuration * 2),

      communities: setInterval(() => {
        setCounts(prev => {
          if (prev.communities >= targets.communities) {
            clearInterval(intervals.communities);
            return prev;
          }
          return { ...prev, communities: prev.communities + 1 };
        });
      }, stepDuration / 2),

      projects: setInterval(() => {
        setCounts(prev => {
          if (prev.projects >= targets.projects) {
            clearInterval(intervals.projects);
            return prev;
          }
          return { ...prev, projects: prev.projects + 1 };
        });
      }, stepDuration / 4)
    };

    return () => {
      Object.values(intervals).forEach(interval => clearInterval(interval));
    };
  }, [isVisible]);

  return (
    <section className="hss-section" ref={sectionRef}>
      <Container>
        {/* Top Content */}
        <Row className="hss-header">
          <Col lg={8} md={12}>
            <p className="hss-tag">Impact causes</p>
            <h2 className="hss-heading">
              Support development and transform lives
            </h2>
          </Col>
          <Col lg={4} md={12} className="text-lg-end text-start">
            <Button
              className="hss-btn-donate"
              onClick={handleDonorLogin}
              disabled={loading}
            >
              {loading ? (
                <span className="hss-btn-spinner" />
              ) : (
                <>
                  Donate now
                  <i className="bi bi-arrow-right ms-2"></i>
                </>
              )}
            </Button>
          </Col>
        </Row>

        {/* Stats Grid - Animated */}
        <Row className="hss-grid">
          {/* Stat 1 - Donations */}
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="hss-stat-box">
              <h3 className="hss-stat-number">
                ${counts.donations}M
              </h3>
              <p className="hss-stat-label">Donations received</p>
            </div>
          </Col>

          {/* Stat 2 - Families */}
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="hss-stat-box">
              <h3 className="hss-stat-number">
                {counts.families}K
              </h3>
              <p className="hss-stat-label">Families supported</p>
            </div>
          </Col>

          {/* Stat 3 - Communities */}
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="hss-stat-box">
              <h3 className="hss-stat-number">
                {counts.communities}+
              </h3>
              <p className="hss-stat-label">Communities served</p>
            </div>
          </Col>

          {/* Stat 4 - Projects */}
          <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
            <div className="hss-stat-box">
              <h3 className="hss-stat-number">
                {counts.projects}+
              </h3>
              <p className="hss-stat-label">Projects implemented</p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Decorative Elements */}
      <div className="hss-decoration-1"></div>
      <div className="hss-decoration-2"></div>
    </section>
  );
}

export default HomeSubScreen;